import { OptionsFormField, PlaceholderFormField } from '../components/fields';
/**
 * Represents various attributes of attribute types in the custom attribute
 * form.
 */
export const attributeTypeFormAttributes = {
    text: {
        label: 'Text',
        data_type: 'string',
        isDisabled: false,
        fields: [PlaceholderFormField],
    },
    select: {
        label: 'Select',
        data_type: 'string_set',
        isDisabled: false,
        fields: [OptionsFormField],
    },
};
